"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddressDto = instanceOfAddressDto;
exports.AddressDtoFromJSON = AddressDtoFromJSON;
exports.AddressDtoFromJSONTyped = AddressDtoFromJSONTyped;
exports.AddressDtoToJSON = AddressDtoToJSON;
exports.AddressDtoToJSONTyped = AddressDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the AddressDto interface.
 */
function instanceOfAddressDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('line1' in value) || value['line1'] === undefined)
        return false;
    if (!('line2' in value) || value['line2'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined)
        return false;
    if (!('lat' in value) || value['lat'] === undefined)
        return false;
    if (!('lng' in value) || value['lng'] === undefined)
        return false;
    if (!('timezone' in value) || value['timezone'] === undefined)
        return false;
    if (!('zealWorkLocationId' in value) || value['zealWorkLocationId'] === undefined)
        return false;
    return true;
}
function AddressDtoFromJSON(json) {
    return AddressDtoFromJSONTyped(json, false);
}
function AddressDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'line1': json['line1'],
        'line2': json['line2'],
        'city': json['city'],
        'state': (0, State_1.StateFromJSON)(json['state']),
        'postalCode': json['postalCode'],
        'lat': json['lat'],
        'lng': json['lng'],
        'timezone': json['timezone'],
        'zealWorkLocationId': json['zealWorkLocationId'],
    };
}
function AddressDtoToJSON(json) {
    return AddressDtoToJSONTyped(json, false);
}
function AddressDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': (0, State_1.StateToJSON)(value['state']),
        'postalCode': value['postalCode'],
        'lat': value['lat'],
        'lng': value['lng'],
        'timezone': value['timezone'],
        'zealWorkLocationId': value['zealWorkLocationId'],
    };
}
//# sourceMappingURL=AddressDto.js.map